import { setList, createUpdateItem, setSelected, removeItem, setOrder } from './routeSlice';
import api, { normalize } from 'api';
import { get } from 'lodash';
import { order } from './selector';

export const getList = (params, callback) => async dispatch => {
  
  try{
    const response = await api.get(`site/routes`, {
      params: { ...params },
    })

    const reponseWithMeta = normalize(response, { endpoint: 'routes' })
    const routes = reponseWithMeta.routes || {}
    const order = get(reponseWithMeta, 'meta.routes.data', []).map(x => x.id)

    await dispatch([
      setList(routes),
      setOrder(order)
    ])

    if(response && callback)
      await callback()

  }catch(e){
    console.log(e)
  }
  
} 

export const create = (payload, callback) => async (dispatch, getState) => {
  
  try{

    const response = await api.post('site/routes', payload)
    const routes = normalize(response).routes || {}
    
    
    await dispatch([
      setOrder([...order(getState()), Object.keys(routes)[0] ]),
      createUpdateItem(routes)
    ])
    
    if(callback)
      await callback(routes)
  }catch(e){
    console.log(e)
  }
} 

export const update = (id, payload, callback) => async dispatch => {
  try{

    const response = await api.put(`site/routes/${id}`, payload)
    const routes = normalize(response).routes || {}
    await dispatch(createUpdateItem(routes))

    if(callback)
      await callback(routes)
  }catch(e){
    console.log(e)
  }
} 

export const show = setSelected

export const remove = (id, callback) => async dispatch => {
  try{
    const response = await api.delete(`site/routes/${id}`)
  
    await dispatch(removeItem(id))

    if(callback)
      await callback(response)
  }catch(e){
    console.log(e)
  }
  
} 
